﻿
import './framework.less'
import 'urlpattern-polyfill';

import { Navigation } from './navigation.js'
import AdaUpButton from '../components/adaUpButton.js';

import Lenis from 'lenis';

let lenis = null;

const init = async () => {

    lenis = new Lenis({
        autoRaf: true
    });
    var nav = new Navigation();
    var upBtn = new AdaUpButton();
    window.addEventListener("scrollStop", (e) => {
        scrollControl(true);
    });

    window.addEventListener("scrollStart", (e) => {
        scrollControl(false);
    });

    window.addEventListener("narration", (e) => {
        document.querySelector("#announce").innerHTML = `<p>${e.detail}</p>`;
    });

}

const basePath = '/';
const homepagePattern = new URLPattern(`${basePath}`, window.origin);
const isHomepage = (url) => {
    return homepagePattern.exec(url);
}

let scrollPos = 0;

window.addEventListener("pageswap", async (e) => {

    if (e.activation) {
        const currentUrl = e.activation.from?.url ? new URL(e.activation.from.url) : null;
        const targetUrl = new URL(e.activation.entry.url);

        if (e.viewTransition) {


            if (isHomepage(targetUrl)) {
                e.viewTransition.types.add('to-homepage');
                console.log("swap: to homepage");

            } else {
                e.viewTransition.types.add('from-homepage');
                console.log("swap: from homepage");
            }
        }
    }
});

window.addEventListener("pagereveal", async (e) => {
    if (!navigation.activation.from) return;

    const fromUrl = new URL(navigation.activation.from.url);
    const currentUrl = new URL(navigation.activation.entry.url);

    if (e.viewTransition) {

        if (isHomepage(currentUrl)) {
            e.viewTransition.types.add('to-homepage');
            console.log("reveal: to homepage");

        } else {
            e.viewTransition.types.add('from-homepage');
            console.log("reveal: from homepage");
        }
    }
});



const scrollControl = (stop) => {

    if (stop) {
        if (lenis) {
            lenis.destroy();
        }
    } else {
        lenis = new Lenis({
            autoRaf: true
        });
    }
}

if (document.readyState !== 'loading') {
    init();
} else {
    document.addEventListener('DOMContentLoaded', function () {
        init();
    });
}